import React from 'react';
import {
  Icon,
  IconName,
  Text,
} from '@usealloy/component-library';
import { NODE_HEIGHT_XL } from 'flow/service/graph';
import type { SnippetNode as ISnippetNode, WorkflowNodeProps } from 'flow/service/graph';
import BaseNode from '../BaseNode';
import {
  StyledDropNode,
  StyledLabelContainer,
  StyledLabelText,
  StyledSnippetIconContainer,
  StyledVersionBadge,
} from './styles';
import { useAppSelector } from '~/store/reduxHooks';
import { selectNodeState, selectSnippetCollapsedState } from 'flow/store/redux/selectors';

function SnippetNode(props: WorkflowNodeProps<ISnippetNode>) {
  const { id, type, data: { children } } = props;
  const { isCollapsed } = useAppSelector(state => selectSnippetCollapsedState(id)(state));
  const nodeState = useAppSelector(state => selectNodeState(state, id));

  // Todo:
  // - dynamically load in snippet configurations
  // - when expanded, add in background behind a snippet's laid out childen

  const SnippetIcon = (
    <StyledSnippetIconContainer>
      <Icon
        icon={IconName.AddressCard}
        size="large"
        color="var(--cl-gray-000)"
      />
    </StyledSnippetIconContainer>
  );

  const labelText = isCollapsed
    ? `${children.length} ${children.length === 1 ? 'Node' : 'Nodes'}`
    : 'Linked Snippet';

  const Label = (
    <StyledLabelContainer>
      <Text size={1} style={{ color: 'var(--cl-text-muted)' }}>
        {labelText}
      </Text>
      <StyledLabelText>
        Snippet Name
      </StyledLabelText>
    </StyledLabelContainer>
  );

  const VersionBadge = (
    <StyledVersionBadge>
      v1
    </StyledVersionBadge>
  );


  return (
    <>
      <BaseNode
        id={id}
        icon={SnippetIcon}
        label={Label}
        style={{
          borderRadius: 'var(--cl-radius-3)',
          border: '1px solid var(--cl-juicyBlue-100)',
          height: `${NODE_HEIGHT_XL}px`,
          padding: 'var(--cl-space-1) var(--cl-space-2)',
        }}
        stateStyle={{
          baseBackgroundColor: 'var(--cl-gray-000)',
          highlighted: {
            backgroundColor: 'var(--cl-gray-000)',
          },
          hovered: {
            backgroundColor: 'var(--cl-gray-100)',
          },
        }}
        type={type}
        disable={{ nodeMenu: isCollapsed, nodeMenuHoverState: !isCollapsed }}
      >
        {!isCollapsed && VersionBadge}
      </BaseNode>
      {
        /** Conditionally render a backdrop node, layered behind the main BaseNode. */
        isCollapsed && <StyledDropNode nodeState={nodeState} />
      }
    </>
  );
}

export default React.memo(SnippetNode);
